<template>
  <div>
    <HeaderNav/>
    <router-view/>
    <FooterBar/>
  </div>
</template>

<script>
  import HeaderNav from '@/components/HeaderNav.vue'
  import FooterBar from '@/components/FooterBar.vue'
  export default {
    name: 'Epicentric-app',
    components: {
      HeaderNav,
      FooterBar
    },
    created () {
      let currentLang = localStorage.getItem('lang')
      if (currentLang === null) {
        const userLang = navigator.language || navigator.userLanguage
        if (userLang.toLowerCase().includes('it')) {
          this.$i18n.locale = 'it'
        } else {
          this.$i18n.locale = 'en'
          // this.$i18n.locale = 'it'
        }
        localStorage.setItem('lang', this.$i18n.locale)
      } else {
        this.$i18n.locale = currentLang
      }

      const currentVersion = localStorage.getItem('version')
      if (currentVersion === null) {
        localStorage.setItem('version', window.wikiVersion)
        location.reload(true)
      } else {
        if (window.wikiVersion > currentVersion) {
          localStorage.setItem('version', window.wikiVersion)
          location.reload(true)
        }
      }
    }
  }
</script>

<style lang="scss">
@import "@/assets/sass/_reset.scss";
@font-face {
  font-family: 'titilliumWeb-Bold';
  src: url('./assets/fonts/TitilliumWeb-Bold.ttf') format('truetype');
  font-weight: normal;
  font-style: normal;
}
@font-face {
  font-family: 'titilliumWeb-Light';
  src: url('./assets/fonts/TitilliumWeb-Light.ttf') format('truetype');
  font-weight: normal;
  font-style: normal;
}
@font-face {
  font-family: 'titilliumWeb-Regular';
  src: url('./assets/fonts/TitilliumWeb-Regular.ttf') format('truetype');
  font-weight: normal;
  font-style: normal;
}
body, html{
  width: 100%;
  background-color: $BG_B;
  background-image: url('./assets/images/background2022.webp');
  background-repeat: no-repeat;
  background-attachment: fixed;
  background-size: cover;
}

#app {
  width: 100%;
  font-family: 'titilliumWeb-Light';
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: $TEXT_B;
  h1, h2, h3, h4, h5{
    text-transform: uppercase;
    &.bold{
      font-family: 'titilliumWeb-Bold';
    }
    .bold{
      font-family: 'titilliumWeb-Bold';
    }
    &.white{
      color: $TEXT_W;
    }
    &.orange{
      color: $ORANGE;
    }
    &.subtitle{
      font-size: 1.5rem;
    }
  }
  .txt-r{
    text-align: right;
  }
  p{
    text-align: left;
    font-size: 1.1rem;
    line-height: 1.4rem;
    &.bold{
      font-family: 'titilliumWeb-Bold';
    }
    .bold{
      font-family: 'titilliumWeb-Bold';
    }
    &.white{
      color: $TEXT_W;
    }
    &.bigger{
      font-size: 1.4rem;
      line-height: 1.7rem;
    }
    &.with-border{
      padding: 28px;
      border: 1px solid lightgray;
    }
  }
  .with-box-orange{
    padding: 28px;
    border: 1px solid $ORANGE;
  }
  .with-box-grey{
    padding: 28px;
    border: 1px solid lightgray;
  }
  i{
    font-style: italic!important;
  }
  a{
    &.link{
      color: $GREEN;
    }
    &.link-btn{
      display: inline-block;
      position: relative;
      .off{
        width: 100%;
        opacity: 1;
      }
      .over{
        position: absolute;
        top: 0px;
        left: 9px;
        width: 100%;
        z-index: 9;
        opacity: 0;
        transition: all .4s ease-out;
      }
      &:hover{
        .over{
          opacity: 1;
        }
      }
    }
  }
  ol, ul{
    font-size: 1.1rem;
    line-height: 1.4rem;
    .bold{
      font-family: 'titilliumWeb-Bold';
    }
    li{
      text-align: left;
      margin-bottom: 7px;
    }
  }
  @media screen and (max-width: 768px) {
    ol, ul{
      padding-left: 20px;
    }
  }
  hr{
    border-color: $ORANGE;
  }
  img{
    max-width: 850px;
    &.centered{
      margin: 0 auto;
    }
    &.full-w{
      width: 100%;
    }
    &.is-desktop{
      display: initial;
    }
    &.is-mobile{
      display: none;
    }
    &.opacity-90{
      opacity: .9;
    }
    &.opacity-80{
      opacity: .8;
    }
    &.opacity-70{
      opacity: .7;
    }
  }

  .loader-circles{
    width: 35px;
    height: 35px;
    z-index: 9999999999;
    .lds-ripple {
      display: inline-block;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 80px;
      height: 80px;
    }
    .lds-ripple div {
      position: absolute;
      border: 4px solid $ORANGE;
      opacity: 1;
      border-radius: 50%;
      animation: lds-ripple 1s cubic-bezier(0, 0.2, 0.8, 1) infinite;
    }
    .lds-ripple div:nth-child(2) {
      animation-delay: -0.5s;
    }
    @keyframes lds-ripple {
      0% {
        top: 36px;
        left: 36px;
        width: 0;
        height: 0;
        opacity: 1;
      }
      100% {
        top: 0px;
        left: 0px;
        width: 72px;
        height: 72px;
        opacity: 0;
      }
    }
  }

  @media screen and (max-width: 768px) {
    img{
      &.full-w{
        width: 99%;
      }
      &.is-desktop{
        display: none;
      }
      &.is-mobile{
        display: initial;
      }
    }
  }

  .triangle-down{
    width: 0px;
    height: 0px;
    border-style: solid;
    border-width: 50px 35px 0 35px;
    border-color: $ORANGE transparent transparent transparent;
    transform: rotate(0deg);
    margin: 0 auto;
  }

  .txt-orange{
    color: $ORANGE;
  }
  .txt-green{
    color: $GREEN;
  }
  .txt-c{
    text-align: center;
  }
  .txt-l{
    text-align: left!important;
  }
  .text-orange{
    color: $ORANGE;
  }
  .page{
    padding-top: 60px;
    width: 100%;
    section{
      position: relative;
      width: 100%;
      max-width: 1400px;
      margin: 0 auto;
      padding-bottom: 120px;
      padding-top: 60px;
      border-bottom: 1px solid $ORANGE;
      &.txt-c{
        p{
          text-align: center;
        }
        .content-wrap{
          p{
            text-align: center;
          } 
        }
      }
      &.no-border{
        border: 0px;
      }
      &.bg-grey{
        background-color: $BG_GREY;
      }
      &.white-bg{
        background-color: $BG_W;
      }
      &.white-gradient{
        &:after{
          content: "";
          display: block;
          width: 100%;
          height: 120px;
          position: absolute;
          bottom: 0px;
          left: 0px;
          z-index: 1;
          background: linear-gradient(0deg, rgba(217,217,217,1) 0%, rgba(217,217,217,1) 40%, rgba(255,255,255,1) 100%);
        }
        background-color: $BG_W;
        border-bottom: 0px;
      }
      &.beta-section{
        padding-bottom: 60px;
      }
      .content-wrap{
        text-align: center;
        width: 100%;
        max-width: 1024px;
        margin: 0 auto;
        &.sign-up-box{
          background: rgb(217,217,217);
          background: linear-gradient(90deg, rgba(217,217,217,1) 0%, rgba(255,255,255,1) 50%, rgba(217,217,217,1) 100%);
          padding: 21px;
          border: 1px solid $GREEN;
          p{
            margin-bottom: 20px;
          }
          a{
            display: block;
            background-color: $GREEN;
            color: $TEXT_W;
            border: 1px solid $GREEN;
            padding: 6px 16px;
            text-decoration: none;
            width: 100px;
            margin: 0 auto;
            transition: all .3s ease-out;
            &:hover{
              background-color: $BG_W;
              color: $GREEN;
            }
          }
        }
      }
      &.pb-0{
        padding-bottom: 0px;
      }
      .mb-0{
        margin-bottom: 0px;
      }
      .mb-short{
        margin-bottom: 15px;
      }
      .mb-half{
        margin-bottom: 30px;
      }
      .mb-regular{
        margin-bottom: 60px;
      }
      .mb-double{
        margin-bottom: 120px;
      }
      .mt-regular{
        margin-top: 60px;
      }
    }

    .sub-title{
      width: 100%;
      position: relative;
      margin-bottom: 5px;
      padding-bottom: 30px;
      text-transform: uppercase;
      color: $TEXT_B;
      font-size: 1.5rem;
      font-family: 'titilliumWeb-Light';
      &.text-orange{
        font-size: 1rem;
        line-height: 1.5rem;
        text-transform: initial;
        color: $ORANGE;
        &:before {
          top: initial;
          bottom: -10px;
          background: $ORANGE;
          background: -webkit-linear-gradient(to left $ORANGE, $ORANGE);
          background: linear-gradient(to left, $ORANGE, $ORANGE);
        }
        &:after {
          top: initial;
          bottom: -14px;
          background: $ORANGE;
          background: -webkit-linear-gradient(to left $ORANGE, $ORANGE);
          background: linear-gradient(to left, $ORANGE, $ORANGE);
        }
      }
      &.text-orange-normal{
        color: $ORANGE;
        &:before {
          background: $ORANGE;
          background: -webkit-linear-gradient(to left $ORANGE, $ORANGE);
          background: linear-gradient(to left, $ORANGE, $ORANGE);
        }
        &:after {
          background: $ORANGE;
          background: -webkit-linear-gradient(to left $ORANGE, $ORANGE);
          background: linear-gradient(to left, $ORANGE, $ORANGE);
        }
      }
      &.text-green{
        color: $GREEN;
        &:before {
          background: $GREEN;
          background: -webkit-linear-gradient(to left $GREEN, $GREEN);
          background: linear-gradient(to left, $GREEN, $GREEN);
        }
        &:after {
          background: $GREEN;
          background: -webkit-linear-gradient(to left $GREEN, $GREEN);
          background: linear-gradient(to left, $GREEN, $GREEN);
        }
      }
      &.text-red{
        color: $RED;
        &:before {
          background: $RED;
          background: -webkit-linear-gradient(to left $RED, $RED);
          background: linear-gradient(to left, $RED, $RED);
        }
        &:after {
          background: $RED;
          background: -webkit-linear-gradient(to left $RED, $RED);
          background: linear-gradient(to left, $RED, $RED);
        }
      }
      &:before {
        content: "";
        display: block;
        height: 1px;
        width: 25%;
        position: absolute;
        bottom: 18px;
        left: 50%;
        transform: translate(-50%, 0);
        background: $GREY;
        background: -webkit-linear-gradient(to left $GREY, $GREY);
        background: linear-gradient(to left, $GREY, $GREY);
      }
      &:after {
        content: "";
        display: block;
        height: 4px;
        width: 12.5%;
        position: absolute;
        bottom: 15px;
        left: 50%;
        transform: translate(-50%, 0);
        background: $GREY;
        background: -webkit-linear-gradient(to left $GREY, $GREY);
        background: linear-gradient(to left, $GREY, $GREY);
      }
    }

    .title-clean {
      font-family: 'titilliumWeb-Light';
      font-size: 2rem;
      color: $TEXT_W;
      text-transform: uppercase;
      &.orange{
        color: $ORANGE;
      }
    }

    .title-box {
      position: relative;
      width: 100%;
      // height: 85px;
      padding-bottom: 30px;
      margin-bottom: 40px;
      text-align: center;
      &.big{
        h1, h2, h3, h4 {
          font-size: 2.5rem;
        }
      }
      &.sub-title{
        h1, h2, h3, h4 {
          font-family: 'titilliumWeb-Regular';
          color: $TEXT_B;
          font-size: 1.8rem;
        }
        &:before {
          background: $TEXT_B;
          background: -webkit-linear-gradient(to left darken($TEXT_B, 20%), $TEXT_B);
          background: linear-gradient(to left, darken($TEXT_B, 20%), $TEXT_B);
        }
        &:after {
          background: $TEXT_B;
          background: -webkit-linear-gradient(to left darken($TEXT_B, 20%), $TEXT_B);
          background: linear-gradient(to left, darken($TEXT_B, 20%), $TEXT_B);
        }
        .title-triangle {
          border-color: $TEXT_B transparent transparent transparent;
        }
        &.white{
          h1, h2, h3, h4 {
            color: $TEXT_W;
            text-transform: none;
          }
          &:before {
            background: $TEXT_W;
            background: -webkit-linear-gradient(to left darken($TEXT_W, 20%), $TEXT_W);
            background: linear-gradient(to left, darken($TEXT_W, 20%), $TEXT_W);
          }
          &:after {
            background: $TEXT_W;
            background: -webkit-linear-gradient(to left darken($TEXT_W, 20%), $TEXT_W);
            background: linear-gradient(to left, darken($TEXT_W, 20%), $TEXT_W);
          }
          .title-triangle {
            border-color: $TEXT_W transparent transparent transparent;
          }
        }
      }
      &.black{
        h1, h2, h3, h4 {
          color: $TEXT_B;
        }
        &:before {
          background: $TEXT_B;
          background: -webkit-linear-gradient(to left darken($TEXT_B, 20%), $TEXT_B);
          background: linear-gradient(to left, darken($TEXT_B, 20%), $TEXT_B);
        }
        &:after {
          background: $TEXT_B;
          background: -webkit-linear-gradient(to left darken($TEXT_B, 20%), $TEXT_B);
          background: linear-gradient(to left, darken($TEXT_B, 20%), $TEXT_B);
        }
        .title-triangle {
          border-color: $TEXT_B transparent transparent transparent;
        }
      }
      h1, h2, h3, h4 {
        font-family: 'titilliumWeb-Light';
        z-index: 5;
        font-size: 2rem;
        color: $TEXT_W;
        text-transform: uppercase;
        &.orange{
          color: $ORANGE;
        }
      }
      &:before {
        content: "";
        display: block;
        height: 1px;
        width: 25%;
        position: absolute;
        bottom: 18px;
        left: 50%;
        transform: translate(-50%, 0);
        background: $ORANGE;
        background: -webkit-linear-gradient(to left darken($ORANGE, 20%), $ORANGE);
        background: linear-gradient(to left, darken($ORANGE, 20%), $ORANGE);
      }
      &:after {
        content: "";
        display: block;
        height: 4px;
        width: 12.5%;
        position: absolute;
        bottom: 15px;
        left: 50%;
        transform: translate(-50%, 0);
        background: $ORANGE;
        background: -webkit-linear-gradient(to left darken($ORANGE, 20%), $ORANGE);
        background: linear-gradient(to left, darken($ORANGE, 20%), $ORANGE);
      }
      .title-triangle {
        position: absolute;
        bottom: -15px;
        left: 50%;
        transform: translate(-50%, 0);
        width: 0;
        height: 0;
        border-style: solid;
        border-width: 21px 12px 0 12px;
        border-color: $ORANGE transparent transparent transparent;
      }
    }
  }
}

@media screen and (max-width: 768px) {
  #app {
    // padding: 0 14px;
    .page{
      section{
        padding-bottom: 60px;
        padding-left: 14px;
        padding-right: 14px;
        &.white-gradient{
          &:after{
            height: 60px;
          }
        }
        .mb-regular{
          margin-bottom: 30px;
        }
      }
    }
  }
}
</style>
